import { getData, patchFormData } from "./index";

export const anonymizedUserList = async (payload) => {
  return getData("admin/anonymizedUserList", payload).then((data) => {
    return data;
  });
};

